import type { PostMessageProps } from 'v2/interfaces/post-message';

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

export function sendPostMessage(data: PostMessageProps): void {
  if (typeof window === 'undefined') {
    return;
  }

  const event = {
    source: data.source,
    action: data.action,
    data: data.data
  };

  const message = JSON.stringify(event);

  if (window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(message);
    return;
  }

  window.postMessage(message, '*');
}
